/**
 * Wave 7 / Lot B — le vide, et la sortie du vide.
 *
 * Un écran vide n'est jamais un cul-de-sac : il porte UN geste utile (écrire au
 * fournisseur, passer une commande, voir les factures). Un seul CTA — le portail
 * s'adresse à un client pressé, pas à un opérateur formé.
 *
 * Ce composant ne doit être rendu qu'après une lecture réellement aboutie
 * (`status === "ready"`) : hors-ligne et erreur ont leurs propres écrans.
 */
import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";

interface Action {
  label: string;
  /** Navigation interne… */
  to?: string;
  /** …ou geste sur place (ouvrir le formulaire de commande). */
  onClick?: () => void;
}

interface Props {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: Action;
}

export function EmptyState({ icon: Icon, title, description, action }: Props) {
  return (
    <div className="rounded-xl2 border border-border bg-card px-6 py-10 text-center">
      <Icon size={40} className="mx-auto mb-3 text-muted" aria-hidden />
      <p className="text-base font-semibold text-ink">{title}</p>
      {description && <p className="mx-auto mt-1 max-w-md text-sm text-muted">{description}</p>}
      {action &&
        (action.to ? (
          <Link
            to={action.to}
            className="mt-4 inline-flex items-center justify-center rounded-xl2 bg-terracotta px-4 py-2.5 text-sm font-semibold text-white hover:bg-terracotta-dark"
          >
            {action.label}
          </Link>
        ) : (
          <button
            type="button"
            onClick={action.onClick}
            className="mt-4 inline-flex items-center justify-center rounded-xl2 bg-terracotta px-4 py-2.5 text-sm font-semibold text-white hover:bg-terracotta-dark"
          >
            {action.label}
          </button>
        ))}
    </div>
  );
}
